import Validator from 'validatorjs';
import { cloneDeep, isEmpty, forEach } from 'lodash';

const getRules = (form) => Object.keys(form).reduce((p, c) => (isEmpty(form[c].rules) ? { ...p } : {
	...p,
	[c] : form[c].rules,
}), {});

const getValues = (form) => Object.keys(form).reduce((p, c) => ({ ...p, [c] : form[c].value }), {});

const validateForm = (formData) => {
	const form = cloneDeep(formData);

	const rules = getRules(form);
	const values = getValues(form);

	const validation = new Validator(values, rules);
	const isValid = validation.passes();

	forEach(form, (value, key) => {
		form[key].validation = !isEmpty(validation.errors.get(key)) ? 'error' : null;
	});

	return {
		form,
		isValid,
		values,
	};
};

export default {
	validateForm,
	getRules,
	getValues,
};
